<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-19 13:34:29
 * @Description: 生成收入报账单
 * @FilePath: \PCMS-Share\src\views\ShareSystem\components\report\approvalForm.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="700px" :close-on-click-modal="false" :before-close="resetForm">
      <span slot="title" class="dialog-title">收入报账单</span>
      <div>
        <el-form ref="form" :rules="rules" :model="formVal" label-width="80px" :inline="true" label-position="right">
          <el-form-item label-width="80px" prop="mianBodyName">
            <span slot="label">主体公司</span>
            <span>{{ formVal.mianBodyName }}</span>
          </el-form-item>
          <el-form-item label-width="80px" prop="submitUserName">
            <span slot="label">申请人</span>
            <span v-if="!formVal.submitUserName" style="color: forestgreen;width: 200px;"
              @click="openAccount">请选择申请人</span>
            <span v-else style="color: forestgreen;" @click="openAccount">
              <el-input v-model="formVal.submitUserName" style="color: forestgreen;width: 250px;"></el-input>
            </span>
          </el-form-item>
          <div>
            <el-form-item label-width="80px" prop="businessType">
              <span slot="label">业务大类</span>
              <el-select v-model="formVal.businessType" placeholder="请选择" filterable clearable style="width:100%">
                <el-option v-for="item in businessBigTypeList" :key="item.operationTypeCode"
                  :label="item.operationTypeName" :value="item.operationTypeName"
                  @click.native="setSmallName(item)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="80px" prop="businessSmallType">
              <span slot="label">业务小类</span>
              <el-select v-model="formVal.businessSmallType" placeholder="请选择" filterable clearable style="width:100%">
                <el-option v-for="item in businessTypeList" :key="item.operationSubTypeCode"
                  :label="item.operationSubTypeName" :value="item.operationSubTypeName"
                  @click.native="setBusinessName(item)"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="paperAttachments">
              <span slot="label">纸质附件</span>
              <el-select ref="selection" v-model="formVal.paperAttachments" style="width: 200px">
                <el-option :key="0" label="无" :value="0"></el-option>
                <el-option :key="1" label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="paperAttachments">
              <span slot="label">备注</span>
              <el-input v-model="formVal.remark" style="width:520px" type="textarea" :rows="2" placeholder="请填写处">
              </el-input>
            </el-form-item>
            <el-form-item prop="paperAttachments">
              <span slot="label">附件</span>
              <FileComponent fileCode="settlementFile" :files="files" @deleteFile="deleteFile1"
                @uplodeSuccess="uplodeSuccess" />
            </el-form-item>
          </div>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetForm">关 闭</el-button>
        <el-button :disabled="isSave" class="bottom_all" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 截图数据 -->
    <div style="position: fixed; top: -10000px;left:10000px;overflow:hidden;">
      <tableMain id="approvalFormTableMain" :ref="`approvalFormTableMain`" :key="`approvalFormTableMain`"
        :tableData="tableDataChild" :tableHead="tableHeadChild" :isImg="true" />
    </div>
    <!-- 核算主体 -->
    <AccountTable ref="accountTable" :dialog.sync="accountDialog" @resetAccount="resetAccount" @setAccount="setAccount" />
    <!-- 项目 -->
    <ProjectTable ref="projectTable" :dialog.sync="projectDia" @resetProject="resetProject" @setProject="setProject" />
    <!-- 费用分摊部门 -->
    <DepTable ref="DepTable" :dialog.sync="depDia" @resetDep="resetDep" @setDep="setDep" />
    <!-- 明细客商 -->
    <detailSupply ref="detailSupply" :dialog.sync="detailSupplyDialog" :detailRow="detailRow" :saveType="saveType"
      @reset="resetSupply" @setDetail="setDetail" />
  </div>
</template>
<script>
import { cardLogin_HX, getUserList_HX, getProject_HX, updateGXCostState } from "@/views/ShareSystem/api/mainHx.js";
import AccountTable from "./accountTable.vue";
import ProjectTable from "./ProjectTable.vue";
import DepTable from "./DepTable.vue";
import detailSupply from "@/views/ShareSystem/components/contract/detailSupply";
import { UPLOAD_TIP } from "@/utils/utils";
import { getToken } from "@/utils/auth";
import { queryData, saveincomeCheckSheet } from "@/api/docking.js";
import {
  getCategory
} from "@/views/ShareSystem/api/mainHx.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import html2canvas from 'html2canvas';
import tableMain from "../tableMain.vue";
import { uploadFile } from "@/api/common.js";
import { _debounce } from '@/utils/utils.js'
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
  components: {
    AccountTable,
    ProjectTable,
    DepTable,
    detailSupply,
    FileComponent,
    tableMain
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    params: {},
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
        status: 1,//只查询启用状态
      },
      accessToken: "",
      total: 0,
      // userData: [],
      projectHxList: [],
      businessBigList: [
        { id: "HSYW227", name: "库存商品出库" },
      ],
      businessSmallList: [
        { id: "HSYW227001", name: "自制库存商品-结转主营业务成本" },
        { id: "HSYW227002", name: "外购库存商品结转主营业务成本" },
      ],
      businessBigTypeList: [],
      rules: {
        submitUserName: [{ required: true, message: "请选择事由", trigger: "change" }],
        sharedProductName: [{ required: true, message: "请选择事由", trigger: "change" }],
        paperAttachments: [{ required: true, message: "请选择事由", trigger: "change" }],
      },
      accountDialog: false, //核算主体
      projectDia: false,//项目
      depDia: false,//分摊部门
      formVal: {
        // accountMainBody:"",
        mianBodyId: "",
        mianBodyName: "",
        businessTime: "",
        paperAttachments: 0,
        submitUserName: "",
        sharedProductCode: "",
        sharedProductName: "",
        businessType: "",
        operationTypeCode: "",
        businessSmallType: "",
        incomeType: "",
        remark: "",
        attachment: "",
        pictureAttachment:"",
      },
      detailSupplyDialog: false,//明细客商
      detailRow: {},
      saveType: "2",
      tableDataChild: [
      ],
      tableHeadChild: [],
      oldAmount: 0,
      table: [
        { label: "业务大类", width: "150px", prop: "operationSubTypeName", status: true },
        { label: "业务类型", width: "150px", prop: "operationSubTypeName", status: true },
        { label: "费用分摊部门", width: "150px", prop: "costShareDepartment", status: true },
        { label: "明细供应商", width: "150px", prop: "detailSupply", status: true },
        { label: "总金额", width: "auto", prop: "money", status: true },
        { label: "事由", width: "150", prop: "resion", status: true },
        { label: "附件", width: "auto", prop: "", status: true },
      ],
      businessTypeList: [[], [], []],
      lowindex: 0,
      fileArr: [],
      uploadFileDig: false,
      upload_tip: UPLOAD_TIP,
      upheader: {},
      loading: false,
      files: [],
      filesPush: [],
      tableDataOver: false,
      isSave:false,
    }
  },
  watch: {

  },
  created() {
    this.upheader = {
      "access-token": getToken(),
    };
  },
  methods: {
    deleteFile1(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        url: 'https://lvshe.huashijc.com/file/' + data.fileUrl,
      };
      const params1 = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params1);
      this.filesPush.push(params);
    },
    lookFile(imgUrl) {
      window.open(imgUrl, "_blank");
    },
    filebefore(file) {
      this.loading = true;
      const allowedFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("数据上传必须是  pdf, jpeg, jpg, png,格式!");
        this.loading = false;
      }
      return isAllowedFormat;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code === 1001) {
        this.tableDataChild[this.lowindex].files.push({
          name: res.data.fileName,
          url: 'https://lvshe.huashijc.com/file/' + res.data.fileUrl
        })
      }
    },
    upFile(index) {
      console.log(this.tableDataChild)
      this.lowindex = index
      this.uploadFileDig = true
    },
    changeFileName() {
      this.tableDataChild.forEach(item => {
        item.files[0].name = item.businessSmallType
      })
    },
    async initData() {
      console.log("this.params----------------------------------")
      console.log(this.params)
      this.formVal = this.$options.data().formVal
      this.formVal.mianBodyId = this.params.mianBodyId
      this.formVal.mianBodyName = this.params.mianBody
      this.formVal.businessTime = this.params.businessTime
      this.formVal.businessSmallType = '商品销售收入-自制非出口'
      this.formVal.incomeType = 'HSSR410004'
      this.formVal.businessType = '制造-销售收入'
      this.formVal.operationTypeCode = 'HSSR410'
      this.formVal.pictureAttachment = this.params.files
      let that = this
      let res = await cardLogin_HX({ idCard: "icps" })
      if (res.code == 1001) {
        let info = res.data;
        if (info && info.accessToken) {
          that.accessToken = info.accessToken
          // this.getUserList(that.accessToken);
          // this.getProject_HX(that.accessToken);
          // this.getBusinessSingle(that.params);
          this.getCategory();
          this.getCategory('制造-销售收入', true)
          this.$emit("openDialog");
        }
      }
    },
    restParams() {
      this.tableParams = {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      }
      this.initData();
    },
    resetSupply() {
      this.detailSupplyDialog = false
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // let num = 0
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          const values = data.map(item => Number(item["totalAmount"]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = '';
          }
        }
        if (index === 3) {
          sums[index] = this.oldAmount;
          return;
        }
      });
      return sums;
    },
    setBusinessName(data) {
      this.formVal.incomeType = data.operationSubTypeCode
    },
    setName(data) {
      this.formVal.employeeCode = data.code
      this.$refs.accountTable.setNcNo(data);
    },
    setSmallName(data) {
      this.formVal.operationTypeCode = data.operationTypeCode
      this.getCategory(data.operationTypeName, true)
    },
    setDetail(param) {
      console.log(param)
      this.tableDataChild[this.lowindex].detailSupply = param.profitCsName
      this.tableDataChild[this.lowindex].venderCode = param.profitCsCode
      this.resetSupply();
    },
    setAccount(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.submitUserName = row.deptName
      this.formVal.deptName = row.deptName
      this.formVal.leCode = row.deptCode
      this.formVal.employeeCode = row.foreignId
      this.formVal.postId = row.positionCode
    },
    setProject(row) {
      // this.formVal.accountMainBody = row.deptName
      this.formVal.sharedProductCode = row.code
      this.formVal.sharedProductName = row.name
    },
    setDep(param) {
      console.log(param)
      this.tableDataChild[this.lowindex].costShareDepartment = param.name
      this.tableDataChild[this.lowindex].expenseDeptId = param.code
      this.resetDep();
    },
    openSupplyDetail(index) {
      this.lowindex = index
      this.detailSupplyDialog = true
      this.$refs.detailSupply.initData();
    },
    openDepDetail(index) {
      this.lowindex = index
      this.depDia = true
    },
    getProject_HX(accessToken) {
      if (!accessToken) {
        this.$message.error('accessToken获取为空～')
        return;
      } else {
        getProject_HX({ page: 1, pageSize: 100 }, accessToken).then((res) => {
          this.projectHxList = res.data?.data;
        });
      }
    },
    getUserList(accessToken) {
      getUserList_HX(accessToken).then((res) => {
        this.userData = res.data;
        console.log(this.userData)
      });
    },
    getCategory(operationTypeName, isSmall) {
      let param = {
        page: 1,
        pageSize: 9999,
        operationTypeName: operationTypeName,
      }
      getCategory(param, this.accessToken).then(res => {
        if (res.code == 1001) {
          if (isSmall) {
            this.businessTypeList = res.data.records[0].mainDictGxBusinessList
          } else {
            this.businessBigTypeList = res.data.records;
          }

        }
      });
    },

    getBusinessSingle(data) {
      let params = {
        businessTime: data.businessTime,
        mianBodyId: data.mianBodyId,
      }
      this.oldAmount = 0
      queryData(params).then((res2) => {
        if (res2.code == 1001) {
          if (res2.data) {
            this.formVal['detailVos'] = res2.data
            // this.fetchAllDataAndGenerateImg()
            this.formVal.detailVos.forEach(item => {
              item['attachmentUrl'] = this.params.files
              item['url'] = `https://lvshe.huashijc.com/#/saleMonthReportDetail_HX?code=${item.icpsCode}`
            })
            this.$emit("openDialog");
          }
        } else {
          this.$emit("mainLoadingClose");

        }
      }).catch(() => {
        this.$emit("mainLoadingClose");
      });
    },
    async fetchAllDataAndGenerateImg() {
      for (let engIndex = 0; engIndex < this.formVal.detailVos.length; engIndex++) {
        const engItem = this.formVal.detailVos[engIndex];
        const res = engItem;
        res.dataList.sort((a, b) => a.engineeringId.localeCompare(b.engineeringId));

        let tableHeadChild = [];
        let tableDataChild = [];

        res.dataList.forEach(item => {
          let headObj = { label: item.settleStationName, prop: item.settleStationName + 'quantity', status: true, width: "70" };
          if (!tableHeadChild.some(item2 => item2.label === item.settleStationName)) {
            tableHeadChild.push(headObj);
          }

          const index = tableDataChild.findIndex(item2 =>
            item2.engineeringId === item.engineeringId && item2.productName === item.productName
          );

          if (index === -1) {
            let obj = { ...item };
            obj['quantityAll'] = Number(obj.quantity);
            obj['taxInclusiveAmountAll'] = Number(obj.taxInclusiveAmount);
            obj[item.settleStationName + 'quantity'] = Number(obj.quantity);
            tableDataChild.push(obj);
          } else {
            tableDataChild[index]['quantityAll'] += Number(item.quantity);
            tableDataChild[index]['taxInclusiveAmountAll'] += Number(item.taxInclusiveAmount);
            tableDataChild[index][item.settleStationName + 'quantity'] = Number(item.quantity);
          }
        });

        this.$set(this, 'tableDataChild', tableDataChild);
        this.$set(this, 'tableHeadChild', tableHeadChild);

        // 等待 generateImg 完成后再继续下一次循环
        await this.generateImg(engIndex);
      }

      // 全部完成后触发事件
      this.$emit('openDialog');
    },

    async generateImg(index) {
      await this.$nextTick();

      return new Promise((resolve, reject) => {
        const tableRef = this.$refs[`approvalFormTableMain`];
        if (!tableRef || !tableRef.$el) {
          return reject(new Error(`未找到 ref approvalFormTableMain`));
        }
        const table = tableRef.$el;
        let bodyWrapper = document.querySelector("#imgTable .el-table__body-wrapper");
        let headerNode = document.querySelector("#imgTable .el-table__header-wrapper");
        let footerNode = document.querySelector("#imgTable .el-table__footer-wrapper");
        let imgTable = document.querySelector("#imgTable");
        //设置新高度
        bodyWrapper.style.height = `${bodyWrapper.scrollHeight}px`;
        bodyWrapper.style.width = `${bodyWrapper.scrollWidth + 100}px`;
        document.getElementById("approvalFormTableMain").style.width = `${bodyWrapper.scrollWidth}px`;
        document.getElementById("approvalFormTableMain").style.height = `${bodyWrapper.scrollHeight + headerNode.scrollHeight + footerNode.scrollHeight}px`;
        imgTable.setAttribute('style', `height: ${bodyWrapper.scrollHeight + headerNode.scrollHeight + footerNode.scrollHeight}px;`);
        const rect = table.getBoundingClientRect();
        html2canvas(table, {
          width: rect.width,
          height: rect.height,
          scrollX: -window.scrollX,
          scrollY: -window.scrollY,
          scale: window.devicePixelRatio || 1,
        }).then(canvas => {
          canvas.toBlob(blob => {
            if (!blob) {
              return reject(new Error('canvas.toBlob 返回了 null'));
            }
            const file = new File([blob], "收入报账单.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);

            uploadFile(params).then(res => {
              if (res.code === 1001) {
                res.data.fileUrl = 'https://lvshe.huashijc.com/file/' + res.data.fileUrl;
                let obj = [{
                  name: res.data.fileName,
                  url: res.data.fileUrl
                }]
                this.formVal.detailVos[index].attachmentUrl = JSON.stringify(obj)
                console.log(res.data.fileUrl);
                resolve(res.data);
              } else {
                this.$emit("mainLoadingClose");
                reject(new Error('上传失败，code=' + res.code));
              }
            }).catch(err => {
              this.$emit("mainLoadingClose")
              reject(err)
            }
            
            );
          });
        }).catch(err => {
          this.$emit("mainLoadingClose")
          reject(err)
        }
        );
      });
    },

    openAccount() {
      this.accountDialog = true
      this.$refs.accountTable.initData();
    },
    resetAccount() {
      this.accountDialog = false
    },
    openProject() {
      this.projectDia = true
    },
    resetProject() {
      this.projectDia = false
    },
    resetDep() {
      this.depDia = false
    },

    resetForm() {
      this.formVal = this.$options.data().formVal
      this.$emit("resetForm");
    },
    //月报量-保存
    submitForm: _debounce(function () {
      if (!this.formVal.submitUserName) {
        this.$message.warning('请选择申请人!')
        return
      }
      if (!this.formVal.remark) {
        this.$message.warning('请填写备注!')
        return
      }
      if (!this.formVal.paperAttachments && this.formVal.paperAttachments != 0) {
        this.$message.warning('请选择纸质附件!')
        return
      }
      if (this.files.length > 0) {
        this.formVal.attachment = JSON.stringify(this.filesPush)
      } else {
        this.formVal.attachment = ""
      }
      this.formVal.checkPushData = {
        remark: this.formVal.remark,//备注
        url:"https://lvshe.huashijc.com/#/saleMonthReportDetail_HX?code=",
        incomeType: this.formVal.incomeType,//业务小类
        employeeCode: this.formVal.employeeCode,//申请人，共享登录账号对应员工编号
        leCode: this.formVal.leCode,//核算主体，前端根据共享接口获取
        operationTypeCode: this.formVal.operationTypeCode,//业务大类
        paperAccessories: this.formVal.paperAccessories,//纸质附件1是;2否
        postCode: this.formVal.postId//岗位编码
      }
      this.isSave = true
      saveincomeCheckSheet(this.formVal).then((res) => {
        if (res.code == 1001) {
          this.isSave = false
          this.$message.success(res.codeMsg)
          this.resetForm();
          this.$router.push({ name: 'incomeSheet', query: { mainBodyId: this.formVal.mianBodyId, businessTime: this.formVal.businessTime } })
        }
        this.isSave = false
      }).catch(() => {
        this.isSave = false
      });
    }, 500),
    updateGXCostState() {
      let param = {
        endTime: this.params.endTime,
        startTime: this.params.startTime,
        lisiTime: this.params.lisiTime,
        settleMonth: this.params.settleMonth,
        companyId: this.params.secondId,
        checkStatus: 0,
        gxStatus: 0
      }
      updateGXCostState(param).then(res => {
        if (res.code == 1001) {
          let dataContent = {
            params: param,
            settlementStartTime: param.startTime,
            settlementEndTime: param.endTime,
            periodSettlement: [param.startTime, param.endTime]
          }
          const query = {
            type: 1,
            taskName: "业务记账单审批表",
            taskStatus: 0,
            taskType: 1,
            dataContent: JSON.stringify(dataContent)
          };
          this.$router.push({ name: 'submitBusinessBilling', query: query })
        }
      }).catch(() => {
        // this.$message.warning(r) 
      })
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.initData();
    },
  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}
</style>